<template>
  <div class="game-container">
    <EngHeader
      :lost="lost"
      :data="data"
      :externalData="externalData"
    ></EngHeader>
    <div class="spaceEng"></div>
    <div v-if="!win && (data || externalData)" class="eng-progress-container">
      <div id="eng-progress-bar" class="eng-progress-bar"></div>
      
    </div>
    <div class="loader" v-if="article.length === 0">
      {{ $t("engGame.allEng.loading") }}
      <!-- <v-progress-circular indeterminate color="primary"></v-progress-circular> -->
      <div
        style="text-align: center; display: flex; justify-content: center; margin: 8px;"
      >
        <SlinkyVue />
      </div>
    </div>
    <!-- <div v-if="win" class="eng-progress">You {{ message }}!</div> -->
    <SentanceSummery
      v-if="win"
      :text="message"
      :currentData="data"
      :externalData="externalData"
      :mistakes="mistakes"
      @restartGame="restartGame"
    />
    <EngGame
      v-if="article && !win"
      :data="article[gameNum]"
      :articleId="articleId"
      :sennum="gameNum"
      :setFail="setFail"
      :setWin="setWin"
    />
  </div>
</template>

<script>
import "./eng.scss";
import EngGame from "./eng.vue";
import EngHeader from "./eng-header.vue";
import SentanceSummery from "./eng-summery.vue";
import { userService } from "../../services/userService";
import SlinkyVue from "../Shared/Slinky.vue";
export default {
  name: "EngGames",
  props: ["data"],
  data() {
    return {
      gameNum: 1,
      lost: 0,
      submitting: false,
      gameid: null,
      win: false,
      mistakes: [],
      message: "win",
      noSound: false,
      isLoadedAudio: false,
      audioSrc: "",
      externalData: null,
      id: null,
      articleIdGame: null,
      updateUser: null
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    article() {
      const gamedata = this.gameid || this.data.game.algolia_game_id;
      // console.log(this.$store.state.gameStore.articles);
      const articles = this.$store.state.gameStore.articles
        .filter(article => {
          return article.article == gamedata;
        })
        .reduce((acc, art) => {
          const senNum = art.sentence.split("_")[1];
          acc[senNum] ? acc[senNum].push(art) : (acc[senNum] = [art]);
          return acc;
        }, []);
      return articles;
    },
    articleNum() {
      return this.article.length - 1;
    },
    articleId() {
      return this.gameid || this.data.game.algolia_game_id;
    }
  },
  created() {
    // this.gameid = this.$route.params.id;
    this.id = this.$route.params.id;
    this.gameid = this.$route.params.gameid;
    this.externalData = this.$route.query;
  },
  mounted() {
    // this.getAudio();
    this.id = this.$route.params.id;
    if (this.data) {
      this.articleIdGame = this.data.game.algolia_game_id;
    } else if (this.gameid) {
      this.articleIdGame = this.gameid;
    }
  },
  beforeDestroy() {
    // this.audioSrc = "";
    this.isLoadedAudio = false;
  },
  watch: {
    updateUser() {
      this.$store.commit("setUser", this.updateUser);
    },
    gameNum() {
      let precent = this.gameNum / this.articleNum * 100
      console.log(precent);
      document.getElementById('eng-progress-bar').style.width = precent + '%'
    },
  },

  methods: {
    setFail(word, num, engwords, hebsen) {
      this.lost = this.lost + 1;
      this.mistakes.push({ word: word, num: num, eng: engwords, heb: hebsen });
      // this.mistakes.push(word);
      // console.log("FAIL");
      if (this.lost === 3) {
        this.message = "lose";
        this.win = true;
      }
    },
    async setWin() {
      if (this.gameNum == this.articleNum) {
        this.playButton();
        this.win = true;
        this.submitting = true;
        // this.gameNum = this.gameNum + 1;
        if (this.data) {
          await userService.finishLesson(this.data.id, this.user);
          await userService.finishGame(this.data.game.id);
        }
        if (this.externalData && this.externalData.id && this.user)
          await userService.finishGame(this.externalData.id);
        if (this.user)
          this.updateUser = await userService.updateSentences([
            { external_id: this.articleIdGame, score: 4 }
          ]);
        this.submitting = false;
      }
      // else { this.gameNum = this.gameNum + 1;
      // }
      this.gameNum = this.gameNum + 1;
      //   id && this.win.push(id[0].sentenceNum);
      //   if (this.win.length == this.sentencesNum) {
      //     console.log("WON DA GAME!");
      //     if (this.data) await userService.finishLesson(this.data.id, this.user);
      //     this.updateUser = await userService.updateSentences([
      //       { extenal_id: this.data.game.algolia_game_id, score: 4 }
      //     ]);
      //     confetti({
      //       particleCount: 100,
      //       spread: 70,
      //       origin: { y: 0.6 },
      //       ticks: 350
      //     });
      //     this.summery = true;
      //   }
    },
    restartGame() {
      console.log(this.gameNum);
      console.log(this.articleNum);
      if (this.gameNum > this.articleNum) this.gameNum = 1;
      // this.gameNum = 1;
      this.lost = 0;

      this.win = false;
      this.message = "win";
    },
    getAudio() {
      this.isLoadedAudio = false;

      const article_id = this.data.game.algolia_game_id;
      fetch(
        `${process.env.VUE_APP_API_URL}/api/sound_file/article_${article_id}_full`
      )
        .then(async response => {
          if (response.status === 200) {
            const { sound_file } = await response.json();

            this.audioSrc = sound_file;
            this.noSound = false;
            this.isLoadedAudio = true;
          } else {
            this.noSound = true;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    playButton() {
      if (!this.noSound && this.isLoadedAudio) {
        const audio = new Audio(this.audioSrc);
        audio.play();
        console.log("Play");
        // this.$refs.player.play();
      }
    }
  },
  components: { EngHeader, EngGame, SentanceSummery, SlinkyVue }
};
</script>

<style scoped>
.loader {
  text-align: center;
  margin: 30px;
}

.eng-progress-container {
  background: var(--header-secondary-lt);
  height: 10px;
  text-align: center;
  direction: ltr;
  font: var(--small-font);
  margin-bottom: 20vh;
}
.eng-progress-bar {
  background: var(--progress-bar-primary);
  width: 0;
  height: 100%;
  -webkit-transition: width 1s ease-in-out;
  -moz-transition: width 1s ease-in-out;
  -o-transition: width 1s ease-in-out;
  transition: width 1s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// allEng.vue?cbe0f72c